/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Batch_Import_CompleteInputs */



/**
* | output |
* | --- |
* | "Batch import complete." |
*
* @param {Batch_Import_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_import_complete = /** @type {((inputs?: Batch_Import_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_Import_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation par lots terminée.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Stapelimport abgeschlossen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione batch completata.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт пакетов завершен.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importación por lotes completada.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("批量导入完成。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("一括インポートが完了しました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बैच आयात पूर्ण हुआ।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importação em lote concluída.")
	return /** @type {LocalizedString} */ ("Batch import complete.")
});